import { render, staticRenderFns } from "./EnacAtplDashboardSelfPacedLearners.vue?vue&type=template&id=40168d65"
import script from "./EnacAtplDashboardSelfPacedLearners.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardSelfPacedLearners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports